import { render, staticRenderFns } from "./AdmisionListaPostulanteBDGFM.vue?vue&type=template&id=d4df367a"
import script from "./AdmisionListaPostulanteBDGFM.vue?vue&type=script&lang=js"
export * from "./AdmisionListaPostulanteBDGFM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports